// extracted by mini-css-extract-plugin
export default {"txtname":"remove_txtname__xZ2RS","modalBody":"remove_modalBody__V18+y","btn":"remove_btn__P5NBl"};